import script from "./SwitchSensitivitySettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchSensitivitySettingPage.vue?vue&type=script&setup=true&lang=js"

import "./SwitchSensitivitySettingPage.vue?vue&type=style&index=0&id=0744223c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0744223c"]])

export default __exports__